import http from "@/utils/request";

// 系统配置  >  审核流程  api

export const massRange = {
	diagnosisList: function (params) {
		return http.get("/erp/assist/erpMassRangeSet/list", params);
	},
	diagnosisTreeList: function (params) {
		return http.get("/erp/assist/erpMassRangeSet/treeData", params);
	},
	newDiagnosis: function (data) {
		return http.post("/erp/assist/erpMassRangeSet/save", data);
	},
	delDiagnosis: function (params) {
		return http.delete("/erp/assist/erpMassRangeSet/delete", params);
	},
	treeData: function () {
		return http.get("/erp/assist/erpMassRangeSet/treeData");
	},
};
